import { useState } from "react";
import NFTGallery from "../../components/nft-gallery";
export default function NFT() {
    const [tireFilter, setTireFilter] = useState(true)
    const [searchNFT, setSearchNFT] = useState()
    return (

        <div className="">
        <div className="flex justify-between flex-wrap items-center">
            <h3 className="text-white whitespace-nowrap mr-[2rem]">All Items</h3>
            <div className="bg-third px-[2.4rem] py-[1.3rem] flex justify-between items-center">
                <input className="outline-none bg-transparent text-[#888B8E] text-[1.6rem] font-poppin" onChange={(e) => setSearchNFT(e.value)} type="text" name="searchNft" placeholder="Search NFT" value={searchNFT} />
                <svg width="2.4rem" height="2.5rem" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 19.5C15.4183 19.5 19 15.9183 19 11.5C19 7.08172 15.4183 3.5 11 3.5C6.58172 3.5 3 7.08172 3 11.5C3 15.9183 6.58172 19.5 11 19.5Z" stroke="#888B8E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M21.0004 21.5004L16.6504 17.1504" stroke="#888B8E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
        </div>
        <div className="w-full mt-[4rem]">
            <NFTGallery />
        </div>
       
    </div>
        //===
       
    )
}